module.exports = __webpack_public_path__ + "media/c-2.1db5c4d2.mp3";